import './src/styles/global.css'
import { getCountryInfo } from './src/utils/pricing-api'

// Warm up the per-country pricing cache on app load so opening the pricing
// page is instant (no fallback-USD flash). The fetch is fire-and-forget; if
// it fails the Pricing.tsx component falls back to its own getCountryInfo
// call which has the same caching.
export const onClientEntry = () => {
  // Defer slightly so it doesn't compete with critical path resources.
  setTimeout(() => { getCountryInfo().catch(() => {}) }, 1500)
}
